export const createAccountStepSx = {
    rootWrapper: {
        py: 14,
        width: "100%",
        display: "flex",
        position: "relative",
        justifyContent: "center",
        flexDirection: { xs: "column", sm: "row" }
    },

    leftFixedBox: {
        width: { xs: "100%", sm: "25%" },
        position: { sm: "fixed" },
        left: { sm: 5 }
    },

    formWrapper: {
        width: '100%',
        display: "flex",
        justifyContent: "center",
    },

    formInner: {
        width: { xs: "100%", sm: "60%", md: "70%", lg: "80%" }
    },

    centerColumn: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center"
    },

    textFieldSpacing: {
        mt: "6px"
    },

    autocomplete: {
        cursor: "pointer",
        border: "none",
        mt: "6px",
        "& .css-1q60rmi-MuiAutocomplete-endAdornment": {
            top: "-15px !important"
        }
    },
    accountSubmittedTextBox: {
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
    },
}
